// extracted by mini-css-extract-plugin
export var filterButton = "_sg-1";
export var filtersContainer = "_sg-0";